// Environment-driven configuration.
//
// Values come from Vite env vars (see .env.example) and fall back to the
// production values so the app still builds when no .env is present.
// Everything here ships to the browser — never add a secret.

const env = import.meta.env ?? {};

const flag = (value, fallback) => (value === undefined ? fallback : String(value) === "true");

export const SUPABASE_URL = env.VITE_SUPABASE_URL || "https://omtnwsownevwaibzpidv.supabase.co";
export const SUPABASE_KEY =
  env.VITE_SUPABASE_PUBLISHABLE_KEY || "sb_publishable_eIbKSjHz5rncDIqwxX645g_3_IBDUpK";
export const SUPABASE_PROJECT_NAME = "BrainMath Game";

export const TURNSTILE_SITE_KEY = env.VITE_TURNSTILE_SITE_KEY || "";

export const IS_LOCAL_DEVELOPMENT = ["localhost", "127.0.0.1", "::1"].includes(location.hostname);
export const PUBLIC_MAINTENANCE_MODE = flag(env.VITE_PUBLIC_MAINTENANCE_MODE, false);
export const BETA_UNLIMITED_AI_CREDITS = flag(env.VITE_BETA_UNLIMITED_AI_CREDITS, true);
export const HAS_UNLIMITED_AI_CREDITS = IS_LOCAL_DEVELOPMENT || BETA_UNLIMITED_AI_CREDITS;

// The teacher-facing AI exercise generator is off pending a redesign. The
// generation edge function, wallet and audit tables stay in place.
export const AI_EXERCISE_GENERATION_ENABLED = flag(env.VITE_AI_EXERCISE_GENERATION_ENABLED, false);

// A beta invite can arrive as ?invite=<token>. Stash it immediately so the
// registration form still finds it after Supabase redirects strip the query.
export const inviteFromURL = new URLSearchParams(location.search).get("invite");
if (inviteFromURL) localStorage.setItem("brainmath-beta-invite", inviteFromURL.trim());
